<template>
  <div>
    <world-nav/>
    <b-form-group id="name" label="名称">
      <b-form-input v-model="info.name" readonly />
    </b-form-group>
    <b-form-group id="memo" label="説明">
      <div class="body" v-html="info.memo" />
      <!-- <remark-editor v-model="info.memo"
        :danger="1000" :warn="800" /> -->
    </b-form-group>
    <b-form-group id="image" label="カード画像">
      <b-form-input v-model="info.icon" debounce="500" readonly />
      <b-img :src="info.icon | coalesceImage" width="80px" height="100px" fluid />
    </b-form-group>
    
    <div class="ctrl-bar">
      <b-button type="button" @click="$router.back()">戻る</b-button>
    </div>
  </div>
</template>

<script>
import { phina } from '@/canvas'
import WorldNav from '@/components/WorldNav'
// import ResponseMessage from '@/components/ResponseMessage'
// import CodeEditor from '@/components/CodeEditor'
// import RemarkEditor from '@/components/RemarkEditor'
// import { default as CommandEditor } from '@/components/CommandEditor'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
export default {
  filters: {
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  components: {
    WorldNav,
    // RemarkEditor,
    // CommandEditor,
    // Digest
    // ResponseMessage,
    // CodeEditor
  },
  mixins: [mixinPlayer],
  props: {
    value: Object,
    importCard: Array,
  },
  computed: {
    card () { return this.importCard[this.$route.params.index] },
    info () { return _.find(this.card, {'@method':'info'}).args },
    addEvent () { return _.find(this.card, {'@method':'add'}) },
    nextCount () { return _.find(this.card, {'@method':'next-count'}) },
    removeEvent () { return _.find(this.card, {'@method':'remove'}) },
    enableDiceBattle: {
      get () { return _.find(this.card, {'@method':'add'}) },
      set (v) {
        if(v){
          this.card.push({
            '@method':'add',
            code:[],
            args:{ command:{'@self':'class-path'} },
            hook:['buff2.add']
          })
          this.card.push({
            '@method':'next-count',
            code:[],
            args:{},
            hook:['buff2.count']
          })
          this.card.push({
            '@method':'remove',
            call:'base-buff-cmd.remove',
            args:{ name:'' },
            hook:['buff2.remove']
          })
        }else{
          _.remove(this.card, {'@method':'add'})
          _.remove(this.card, {'@method':'next-count'})
          _.remove(this.card, {'@method':'remove'})
        }
      }
    },
    addCommand () {
      return {
        code:[
          'free/buff/status',
          'free/passive/buff'
        ],
        hook:[
          'buff2.add'
        ]
      }
    },
    removeCommand () {
      return {
        hook:[
          'buff2.remove'
        ]
      }
    },
    nextCountCommand () {
      return {
        code:[
          'free/attack/buff',
          'free/heal/buff'
        ],
        hook:[
          'buff2.count',
          'character.passive-action'
        ],
      }
    },
  },
  data () {
    return {
      innerValue: this.value,
    }
  },
  methods: {
    preview (data) {
      this.$store.dispatch('getCodePreview', { 
          code: data,
          complement: 1
        })
        .then((response) => {
          this.$store.dispatch('setCode', response.code)

          // eslint-disable-next-line
          phina.global.app.pushScene(RequestScene({
            assets: response.assets,
            success: (_response, args)=>{
              this.$emit('changePlayer', 'l-player')
              args.$extend(response)
                .$extend({ store:this.$store, bg:'img/ui/bg.png' });
              return 'StoryScene'
            }
          }))
        })
    },
    // removeCard () {
    //   this.innerValue.card.splice(this.$route.params.index, 1)
    //   this.$router.push('/buff')
    // }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare {
  width: 100%;
  height: 400px;
}
.event-ctrl-bar {
  display: flex;

  .digest {
    margin-left: 10px;
  }
}
.ctrl-bar {
  padding: 10px;

  display: flex;
  justify-content: space-between;
}
.body {
  p {
    margin: 0;
  }
  ::v-deep .ql-size-large {
    font-size: 1.5em;
  }
  ::v-deep .ql-size-small {
    font-size: .75em;
  }
  ::v-deep .ql-size-huge {
    font-size: 2.5em;
  }
}
</style>
